
import { IoIosRefresh } from "react-icons/io";
import { lazy } from "react";

const VersionNotes = lazy(() => import("./Atualizacao/VersionNotes").then((m) => ({ default: m.VersionNotes })));

const ModuleAtualizacao = {
  menuItem: {
    to: "/atualizacao",
    title: "Atualizações",
    icon: IoIosRefresh,
    id: 16,
    childrens: [
      {
        to: "/version",
        title: "Notas da Versão",
        fullTitle: "Notas",
        id: 80,
      },
    ],
  },

  routes: [
    {
      path: "/version",
      element: <VersionNotes />,
    },
  ],
};

export default ModuleAtualizacao;
